export interface NewsItem {
  id: string;
  title: string;
  date: string;
  summary: string;
  content: string[];
  cover: string;
  tags: string[];
  relatedShowIds?: string[];
}

export const newsList: NewsItem[] = [
  {
    id: 'news-001',
    title: '《长安月下》收官：悬疑与权谋交织，豆瓣开分8.7',
    date: '2026-10-10',
    summary: '古装悬疑剧《长安月下》正式收官，凭借紧凑的探案节奏与细腻的人物刻画获得观众一致好评。',
    content: [
      '古装悬疑剧《长安月下》于昨晚迎来大结局，该剧自开播以来热度持续攀升，豆瓣开分即达8.7，成为近期口碑与热度双丰收的代表作品。',
      '剧集讲述御史裴衍与神秘捕快阿璃联手追查长安城连环命案，层层揭开尘封多年的宫廷旧案。有观众评价，该剧节奏紧凑，反转不断，同时在悬疑外壳下包裹着细腻的情感线，是近年来古装探案题材中难得的佳作。',
      '主演林疏桐在采访中表示，为了塑造好阿璃这一角色，自己提前数月学习武术与骑射，力求呈现出角色干练果敢的一面。该剧的成功也让原班人马的下一部合作备受期待。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20period%20mystery%20drama%20behind%20the%20scenes%2C%20ancient%20city%20night%20set%20with%20lantern%20light%2C%20deep%20navy%20blue%20tone%2C%20editorial%20news%20photography%20style&width=1200&height=675&seq=news-001-a&orientation=landscape',
    tags: ['收官', '古装悬疑', '口碑'],
    relatedShowIds: ['tv-001'],
  },
  {
    id: 'news-002',
    title: '电影《浪潮之上》路演启动，主创畅谈拍摄幕后',
    date: '2026-10-08',
    summary: '励志体育电影《浪潮之上》开启全国路演，导演周明远分享海上实景拍摄的艰辛与收获。',
    content: [
      '由周明远执导的励志电影《浪潮之上》于本周正式开启全国路演，首站选在沿海城市，现场气氛热烈。',
      '导演周明远在映后交流中透露，影片中大量的冲浪镜头均为实景拍摄，主创团队在海上连续作业数月，克服了天气多变、海况复杂等诸多困难，只为呈现出最真实的视觉效果。',
      '主演陈野也在现场分享了自己为角色进行专业冲浪训练的经历，笑称这是自己拍过最"辛苦但值得"的一部作品。影片上映以来口碑持续发酵，不少观众表示被片中角色的拼搏精神所打动。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Film%20roadshow%20event%20behind%20the%20scenes%2C%20director%20and%20actor%20on%20stage%20talking%20to%20audience%2C%20warm%20orange%20stage%20lighting%2C%20cinematic%20editorial%20photography&width=1200&height=675&seq=news-002-a&orientation=landscape',
    tags: ['路演', '幕后', '励志电影'],
    relatedShowIds: ['movie-001'],
  },
  {
    id: 'news-003',
    title: '年度家庭剧盘点：这几部作品为何打动了无数观众',
    date: '2026-10-05',
    summary: '从《烟火人间》到《岁月如歌》，近年来家庭伦理题材持续走红，我们盘点其中的共性与亮点。',
    content: [
      '近几年，家庭伦理题材电视剧屡屡成为话题之作，从正在热播的《烟火人间》到此前口碑炸裂的年代剧《岁月如歌》，这类作品持续引发观众的情感共鸣。',
      '业内分析认为，这类剧集之所以能够打动人心，关键在于其扎根生活、拒绝悬浮的创作态度。无论是三代同堂的日常琐碎，还是跨越四十年的时代变迁，创作者都力求用真实细腻的细节还原普通中国家庭的喜怒哀乐。',
      '与此同时，家庭剧也在不断尝试与悬疑、年代、职场等类型元素融合，拓展了题材的表现空间，为观众带来更丰富的观剧体验。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20family%20watching%20TV%20together%20at%20home%2C%20warm%20cozy%20living%20room%2C%20orange%20evening%20light%2C%20editorial%20lifestyle%20photography&width=1200&height=675&seq=news-003-a&orientation=landscape',
    tags: ['盘点', '家庭剧', '口碑分析'],
    relatedShowIds: ['tv-002', 'tv-005'],
  },
  {
    id: 'news-004',
    title: '韩国悬疑片《雾中迷局》引进上映，烧脑反转获赞',
    date: '2026-10-02',
    summary: '韩国悬疑犯罪片《雾中迷局》正式引进国内院线，层层反转的剧情获得观众与影评人双重好评。',
    content: [
      '韩国悬疑犯罪电影《雾中迷局》于本周正式登陆国内院线。影片讲述退休警探重启十年悬案的故事，上映后迅速引发观众热议。',
      '不少观众表示，影片剧情环环相扣，直到最后一刻才揭晓真相，观影过程中数次被反转打破预期。影评人则认为，该片在悬疑叙事的基础上，也对权力与正义的关系进行了深刻探讨。',
      '据悉，该片在原产地上映期间已收获多项电影奖项提名，此次引进也让更多国内观众得以欣赏到这部口碑佳作。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20film%20screening%20event%2C%20dark%20cinema%20hall%20with%20blue%20screen%20light%2C%20audience%20silhouette%2C%20editorial%20cinematic%20photography&width=1200&height=675&seq=news-004-a&orientation=landscape',
    tags: ['引进片', '韩国电影', '悬疑'],
    relatedShowIds: ['movie-002'],
  },
  {
    id: 'news-005',
    title: '《青春合伙人》主演见面会人气爆棚，粉丝热情高涨',
    date: '2026-09-28',
    summary: '都市创业剧《青春合伙人》主演团队现身粉丝见面会，与观众分享拍摄趣事。',
    content: [
      '正在热播的都市创业题材剧集《青春合伙人》于本周末举办主演见面会，现场吸引大批观众到场支持，气氛十分热烈。',
      '四位主演韩哲、夏梦、赵子轩、林微悉数到场，分享了拍摄期间的趣事与团队默契的建立过程。主演韩哲表示，剧中创业团队的情谊也延续到了现实生活中，几位主演私下关系十分要好。',
      '该剧凭借轻快的节奏与贴近年轻人生活的创业故事，自开播以来持续收获高关注度，成为近期热度上升最快的剧集之一。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Fan%20meeting%20event%20with%20young%20actors%20on%20stage%2C%20bright%20modern%20venue%2C%20warm%20orange%20spotlight%2C%20enthusiastic%20audience%2C%20editorial%20event%20photography&width=1200&height=675&seq=news-005-a&orientation=landscape',
    tags: ['粉丝见面会', '都市剧', '幕后花絮'],
    relatedShowIds: ['tv-004'],
  },
  {
    id: 'news-006',
    title: '影评：《归途》用克制的镜头语言讲述最动人的亲情',
    date: '2026-09-20',
    summary: '电影《归途》自上映以来好评不断，影评人认为其克制细腻的表达方式是最大亮点。',
    content: [
      '电影《归途》自公映以来持续收获观众与影评人的高度评价，影片讲述常年在外打拼的儿子因父亲病重匆忙归乡的故事。',
      '多位影评人指出，影片最可贵之处在于其克制的叙事方式，没有刻意的煽情桥段，却用细腻真实的生活细节，让观众在不知不觉中被打动。',
      '导演贾明在采访中表示，希望通过这部作品，让观众重新思考与家人相处的方式，不要等到来不及的时候才懂得珍惜。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20countryside%20road%20at%20dusk%2C%20emotional%20father%20and%20son%20silhouette%2C%20warm%20orange%20sunset%20light%2C%20editorial%20cinematic%20photography&width=1200&height=675&seq=news-006-a&orientation=landscape',
    tags: ['影评', '家庭电影', '口碑'],
    relatedShowIds: ['movie-004'],
  },
];